import { Form } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import { CheckboxField, DateField, InputField, MultipleSelectField } from 'components/shared/input'
import { Symptom } from '../result_v2'
import { LiteTestResultForm } from 'api/result_lite'
import { Button } from 'react-bootstrap'
import { Dispatch, SetStateAction } from 'react'
import { LiteSample } from '@craif/product.lite_sample'
import misignalCalculatorAxiosBase from 'utils/network/misignal_calculator_axios_base'

type LiteTestViewProps = {
    form: Form<LiteTestResultForm>
    formPrev: Form<LiteTestResultForm>
    formPrev2: Form<LiteTestResultForm>
    formPrev3: Form<LiteTestResultForm>
    formPrev4: Form<LiteTestResultForm>
    symptoms: Symptom[]
    setSample: Dispatch<SetStateAction<LiteSample | undefined>>
}

export const LiteTestView = ({ form, formPrev, formPrev2, formPrev3, formPrev4, symptoms, setSample }: LiteTestViewProps) => {
    const patientId = "xxxxxx" // patientIdは文字列になるように仕様変更 2024/10
    const generateEnabledJson = () => {
        const samples = [form, formPrev, formPrev2, formPrev3, formPrev4].filter((f) => f.object.enabled).map((f, index) => formatFormData(f, index + 1))

        return {
            version: '2.1',
            patients: [
                {
                    id: patientId,
                    samples,
                },
            ],
        }
    }

    const handleGenerateEnabledJson = async () => {
        const json = generateEnabledJson()
        console.log(JSON.stringify(json, null, 2))
        // ここで結果表を表示する処理を書く
        const result = await misignalCalculatorAxiosBase().post('/', json, {
            headers: {
                Authorization: process.env.REACT_APP_MISIGNAL_CALCULATOR_API_KEY,
            },
        })

        const patientResultData = result.data['results'][patientId]

        console.log('result!!! patientResultData', patientResultData)

        const testSample: LiteSample = {
            code: 'RL_xxxxxx',
            status: 'APPROVED',
            isInterviewed: true,
            warehousedAt: new Date().toISOString(),
            requestForm: {},
            background: {
                code: 'test',
                age: 60,
            } as any,
            resultJson: patientResultData,
            resultValue: patientResultData.value,
            arrivedAt: new Date().toISOString(),
            patientId: 1,
            institutionId: 1,
            patient: {
                id: 1,
                familyName: "山田",
                familyNameKana: "ヤマダ",
                givenName: "太郎",
                givenNameKana: "タロウ",
                code: "test",
                gender: "MALE",
                address: {
                    zipCode: '1000000',
                    prefecture: '東京都',
                    city: '千代田区',
                    line: 'テスト町',
                    building: 'テストビル',
                    whole: '1000000 東京都 千代田区 テスト町 テストビル',
                },
                schema: 'remote'
            },
            followupStudyAgreement: false,
            isRecollection: false
        }

        setSample(testSample)
    }
    const formatFormData = (form: Form<LiteTestResultForm>, id: number) => ({
        id,
        date: form.object.inspectionDate,
        value: form.object.resultValue,
        symptoms: form.object.symptoms || [],
        gender: form.object.gender,
    })

    return (
        <>
            <div>
                <LiteControlForm id="form" form={form} title="今回" color="#9002" hideEnableCheck symptoms={symptoms} />
                <LiteControlForm id="formPrev" form={formPrev} title="前回(2回前)" color="#9002" symptoms={symptoms} />
                <LiteControlForm id="formPrev2" form={formPrev2} title="3回前" color="#9002" symptoms={symptoms} />
                <LiteControlForm id="formPrev3" form={formPrev3} title="4回前" color="#9002" symptoms={symptoms} />
                <LiteControlForm id="formPrev4" form={formPrev4} title="5回前" color="#9002" symptoms={symptoms} />
            </div>
            <Button onClick={handleGenerateEnabledJson} style={{ marginTop: 18 }}>
                決定
            </Button>
        </>
    )
}
type LiteControlFormProps = {
    id: string
    form: Form<LiteTestResultForm>
    title: string
    color: string
    symptoms: Symptom[]
    hideEnableCheck?: boolean
}

const LiteControlForm = ({ id, form, title, color, hideEnableCheck, symptoms }: LiteControlFormProps) => {
    const enabled = form.object.enabled

    return (
        <div style={{ padding: 20, backgroundColor: color, width: '100%' }}>
            <Flex style={{}}>
                <div style={{ fontWeight: 'bold' }}>{title}</div>
                {!hideEnableCheck && (
                    <div>
                        <CheckboxField form={form} attr="enabled" checkboxLabel="有効" controlId={title} />
                    </div>
                )}
            </Flex>
            {enabled && (
                <>
                    <Flex>
                        <DateField form={form} attr="inspectionDate" label="検査日" style={{ marginBottom: 0 }} />
                    </Flex>
                    <InputField form={form} attr="resultValue" type="number" label="検査結果の数値" step={1} />
                    <div>疑いのある症状</div>
                    <div style={{ fontSize: 14 }}>
                        <MultipleSelectField id={`all-symptoms-${id}`} form={form} attr="symptoms" selectItems={symptoms} hideSearch horizontal hideSelectAll />
                    </div>
                </>
            )}
        </div>
    )
}
